import { get } from 'es-toolkit/compat';
import { useUserPermissions } from '../PermissionAPI';
import { PermissionDTO } from '../PermissionDTO';
import { resolveHasNoAccess } from './resolvePermissionAccess';

interface PermissionAccess<T extends keyof PermissionDTO> {
  name: T;
  permission: keyof NonNullable<PermissionDTO[T]>;
}

export function usePermissionAccess<T extends keyof PermissionDTO>({
  name,
  permission,
}: PermissionAccess<T>) {
  const { data: userPermission } = useUserPermissions();
  const hasUserPermission = get(userPermission, [name, permission]) as
    | boolean
    | undefined;

  return resolveHasNoAccess(userPermission, hasUserPermission);
}
